import { apiGet, apiPostPut } from "./api_methods";
import { RECRUITER_DASHBOARD_BASE } from "./endpoints";

/**
 * Calculates the month-over-month percentage change (growth/decline) for candidate statuses.
 * It aggregates data across multiple modules (Job Posts, Interviews, Mock Tests, and Resume Sorting).
 * @returns {Promise<{ body, status }>}
 */
export async function getDashboardImprovements() {
  return apiGet(`${RECRUITER_DASHBOARD_BASE}/improvement`);
}

/**
 * Send bulk emails to multiple candidates at once.
 * POST /api/v1/recruiter/dashboard/send-multiple-emails
 * @param {object} payload - { mails: string[], subject: string, text: string, cc?: string|string[], replyTo?: string }
 * @returns {Promise<{ body, status }>}
 */
export async function sendMultipleEmails(payload) {
  return apiPostPut(
    payload,
    `${RECRUITER_DASHBOARD_BASE}/send-multiple-emails`,
    "POST",
  );
}
